import React, { FunctionComponent, useState } from 'react';
import { LandlordFullPageProps } from 'scenes/landlord/types';
import { ExcessStep as CommonExcessStep } from 'scenes/common/components/Steps';
import {
  getSelectedExcesses,
  getPreselectedPrice,
  getSelectedContentsExcess,
  getSelectedCoverType,
  getStandardContentsExcesses,
} from 'scenes/landlord/selectors';
import { HELP_TEXT, LINK_TEXT } from 'scenes/landlord/helpers/excess';

import { ExcessDisclaimer } from 'scenes/common/components/Disclaimer';
import ExcessModal from '../ExcessModal';

export const QUESTION = 'Choose your contents excess';

const ContentsExcessStep: FunctionComponent<LandlordFullPageProps> = ({
  onNext,
  onUpdateContentsExcess,
  funnelState,
  onClickSaveQuoteModal,
}) => {
  const [showModal, setShowModal] = useState(false);

  const standardExcesses = getStandardContentsExcesses(funnelState);

  return (
    <>
      <CommonExcessStep
        question={QUESTION}
        helpText={standardExcesses.length > 1 ? HELP_TEXT : ''}
        helpLink={{
          id: 'helpLink',
          text: LINK_TEXT,
          ariaLabel: `${LINK_TEXT} - Opens dialog`,
          onClick: () => {
            setShowModal(true);
          },
        }}
        defaultStateValue={getSelectedContentsExcess(funnelState)}
        options={standardExcesses}
        quoteDetails={funnelState.apiResponses.quoteDetails}
        coverType={getSelectedCoverType(funnelState)}
        price={getPreselectedPrice(funnelState)}
        onNext={onNext}
        onUpdateExcess={onUpdateContentsExcess}
        onClickSaveQuoteModal={onClickSaveQuoteModal}
        disclaimer={<ExcessDisclaimer />}
      />
      <ExcessModal
        excesses={getSelectedExcesses(funnelState)}
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};

export default ContentsExcessStep;
